const activities = {
  createAnActivity: 'Créer une activité',
  noActivitiesToDisplay: 'Aucune activité à afficher',
  noActivityToDisplay: 'Aucune activité à afficher',
  xSelectedActivities_one: '{{count}} activité sélectionnée',
  xSelectedActivities_other: '{{count}} activités sélectionnées',
};

export default activities;
